import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Convoy, ConvoyCore } from '../types/convoy';
import { Evaluation } from '../types/evaluations';
import { deleteRequest, getRequest, postRequest } from './api';
import { convoyEvaluationsUrl, convoyUrl, convoysUrl } from './urls/convoyUrls';

export const getConvoys = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<Convoy>; error?: ApiError }> => {
  const response = await getRequest(convoysUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const deleteConvoy = async (
  clientId: string,
  subClientId: string,
  convoyId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(convoyUrl(convoyId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateConvoy = async (convoy: ConvoyCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(convoyUrl(convoy._id), {
    body: { ...convoy, subClientId: convoy.subClient, clientId: convoy.client, assets: convoy.assignedAssets },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postConvoy = async (convoy: ConvoyCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(convoysUrl, {
    body: { ...convoy, subClientId: convoy.subClient, clientId: convoy.client, assets: convoy.assignedAssets },
  });

  return {
    id: response?.data?._id,
    error: response?.error,
  };
};

export const getConvoyEvaluations = async (
  clientId: string,
  subClientId: string,
  convoyId: string,
  page: number
): Promise<{ evaluations?: Evaluation[]; total?: number; error?: ApiError }> => {
  const response = await getRequest(convoyEvaluationsUrl(convoyId), {
    queryParams: { clientId, subClientId, page },
  });
  return {
    total: response?.data?.total,
    evaluations: response?.data?.items,
    error: response?.error,
  };
};
